<div class="w-full" style="font-size: 1.1rem;">
    <div class="flex flex-wrap">
        <label class="line-height-3 w-full">
            It looks like your browser settings are preventing this feature from
            working.
          </label>
          <label class="line-height-3 mb-3 w-full">
              Some additional popups are blocked due to your browser's popup
            settings.
          </label>
    </div>
    <label class="text-lg text-primary font-medium">To enable this feature:</label>
    <ol>
      <li class="line-height-3">Go to your browser settings.</li>
      <li class="line-height-3">Find <span class="font-italic text-orange-600 font-semibols">"Pop-ups and redirects"</span> or <span class="font-italic text-orange-600 font-semibols">"Pop-up"</span> or a similar option (Depends on browser).</li>
      <li class="line-height-3">Allow popups for this website or Uncheck <span class="font-italic text-orange-600 font-semibols">"Block pop-up windows"</span> option (Depends on browser).</li>
    </ol>
  </div>

  <!-- OK Button -->
  <div class="flex justify-content-center mt-3">
    <p-button (click)="_diag.close()" label="Ok"  severity="primary"  />
  </div>
